import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { Player } from '@app/_models/player';
import { PlayersService } from '@app/services/players.service';
import { NgForm } from '@angular/forms';
import { Location } from '@angular/common';

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.scss']
})
export class PlayerComponent implements OnInit {

  player: Player;
  player_id: any;
  frmPlayer: NgForm;
  editMode: Boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private playerService: PlayersService,
    private _location: Location
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.player_id = params.get("id");
      this.playerService.getPlayer(this.player_id)
      .subscribe(
        data => {
          this.player = data;
        },
        error => console.log('error: ', error)
      );      
    })

  }

  backClicked() {
    this._location.back();
  }

}
